{
  "title": "Моят профил",
  "subtitle": "Управлявайте показваното име, телефона и паролата",
  "backToAdmin": "Назад към администрация",
  "backToManage": "Назад към управление",
  "backToClient": "Назад към портала",
  "backToHome": "Назад към началото",
  "accountInfo": "Информация за акаунта",
  "editName": "Показвано име",
  "namePlaceholder": "Вашето име",
  "nameHint": "Това име се показва в приложението.",
  "saveName": "Запази името",
  "nameUpdated": "Името е актуализирано успешно",
  "nameUpdateFailed": "Неуспешна актуализация на името",
  "fields": {
    "email": "Имейл",
    "name": "Име",
    "role": "Роля",
    "phone": "Телефон",
    "emailVerified": "Имейл потвърден",
    "phoneVerified": "Телефон потвърден",
    "memberSince": "Член от"
  },
  "verified": "Потвърден",
  "notVerified": "Непотвърден",
  "emailVerifiedTag": "Имейл потвърден",
  "emailNotVerifiedTag": "Имейл не е потвърден",
  "phoneVerified": "Телефонът е потвърден",
  "phoneNotVerified": "Телефонът не е потвърден",
  "phoneSection": "Телефонен номер",
  "changePhone": "Смяна на телефонен номер",
  "addPhone": "Добави телефонен номер",
  "phoneEmptyDescription": "Добавете телефонен номер, за да влизате със SMS след потвърждение.",
  "phoneVerifiedHint": "Този номер е потвърден и може да се използва за вход със SMS.",
  "phoneUnverifiedHint": "Потвърдете номера с SMS код, преди да можете да влизате със SMS.",
  "changePhoneHint": "Въведете нов номер и го потвърдете с SMS кода, който ще изпратим.",
  "copyPhone": "Копирай номера",
  "phoneCopied": "Копирано",
  "sendCode": "Изпрати код за потвърждение",
  "resendCode": "Изпрати кода отново",
  "verifyPhone": "Потвърди телефонния номер",
  "codeLabel": "Код за потвърждение",
  "codeRequired": "Въведете 6-цифрения код",
  "codeSent": "Кодът за потвърждение е изпратен",
  "codeSendFailed": "Неуспешно изпращане на код за потвърждение",
  "codeVerifyFailed": "Неуспешно потвърждаване на телефонния номер",
  "phoneVerifiedSuccess": "Телефонният номер е потвърден успешно",
  "phoneRequired": "Телефонният номер е задължителен",
  "phoneInvalid": "Моля, въведете пълен и валиден телефонен номер",
  "phoneAlreadyUsed": "Този телефонен номер вече е свързан с друг акаунт",
  "phoneAlreadyVerified": "Този телефонен номер вече е потвърден",
  "invalidCode": "Невалиден код за потвърждение",
  "codeExpired": "Кодът е изтекъл. Моля, заявете нов",
  "phoneManageUnavailable": "Потвърждаването на телефон не е налично за вашата роля.",
  "notSet": "Не е зададено",
  "emailSection": "Имейл",
  "addEmail": "Добави имейл",
  "changeEmail": "Смяна на имейл",
  "emailEmptyDescription": "Добавете имейл адрес, за да влизате с имейл след потвърждение.",
  "emailVerifiedHint": "Този имейл е потвърден и може да се използва за вход с парола.",
  "emailUnverifiedHint": "Отворете връзката за потвърждение или я изпратете отново, ако не сте получили имейла.",
  "changeEmailHint": "Въведете нов адрес. Ще изпратим връзка за потвърждение, преди да стане активен.",
  "emailPlaceholder": "you@example.com",
  "emailRequired": "Имейлът е задължителен",
  "emailInvalid": "Моля, въведете валиден имейл адрес",
  "sendEmailVerification": "Изпрати имейл за потвърждение",
  "resendEmail": "Изпрати имейла отново",
  "emailVerificationSent": "Имейлът за потвърждение е изпратен",
  "emailSendFailed": "Неуспешно изпращане на имейл за потвърждение",
  "emailAlreadyUsed": "Този имейл вече е свързан с друг акаунт",
  "emailAlreadyVerified": "Този имейл вече е потвърден",
  "emailVerifiedReadOnly": "Потвърден имейл не може да се сменя от тук",
  "security": "Сигурност",
  "changePassword": "Смяна на парола",
  "currentPassword": "Текуща парола",
  "currentPasswordRequired": "Текущата парола е задължителна",
  "currentPasswordPlaceholder": "Въведете текущата си парола",
  "newPassword": "Нова парола",
  "confirmPassword": "Потвърдете новата парола",
  "confirmPasswordRequired": "Моля, потвърдете новата парола",
  "updatePassword": "Актуализирай паролата",
  "passwordUpdated": "Паролата е актуализирана успешно",
  "passwordUpdateFailed": "Неуспешна смяна на паролата",
  "passwordCreated": "Паролата е създадена успешно",
  "createPassword": "Създай парола",
  "createPasswordHint": "Създайте парола, за да влизате и с имейл.",
  "passwordHint": "Въведете текущата си парола, за да зададете нова.",
  "fixFormErrors": "Моля, коригирайте маркираните полета и опитайте отново.",
  "errors": {
    "currentPasswordIncorrect": "Въведената текуща парола е грешна. Моля, опитайте отново.",
    "passwordCannotBeChanged": "Паролата ви се управлява от доставчика за вход и не може да се промени тук.",
    "passwordAlreadySet": "Вече има зададена парола. Използвайте смяна на парола.",
    "authenticationRequired": "Сесията ви е изтекла. Моля, влезте отново.",
    "forbidden": "Нямате разрешение за това действие.",
    "serverError": "Възникна грешка. Моля, опитайте отново след малко.",
    "loadFailed": "Профилът не може да бъде зареден. Моля, презаредете страницата.",
    "networkError": "Няма връзка със сървъра. Проверете връзката и опитайте отново."
  }
}
